import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { DataContext } from '../App';

function LastUpdated() {
  const data = React.useContext(DataContext);
  var moment = require('moment')
  const { t } = useTranslation('translation', { keyPrefix: 'lastUpdated' });

  var updatedOn = moment(new Date(data.timestamp))//.format('Do MMMM, YYYY') 

  return (
    <Container fluid>
      <Row className='mt-4 mb-4'>
        <Col><h3 className="font-weight-bold text-black">{t('next')}</h3></Col>
        <Col className='sm-text-right xs-text-left sm-text'>
          <p className="text-muted mb-0" >{t('generated')}</p>
          <p className="text-muted mb-0 d-inline">{updatedOn.format('HH:mm DD MMM YYYY')}</p>
        </Col>
      </Row>
    </Container>
  );
    
}

export default LastUpdated;